import React from 'react';

const About = ({ translations }) => {

  const navbarTranslations = translations?.components?.navbar?.translations || {};
  const aboutTilteText = navbarTranslations['menu.title.about'];

  const objectTranslations = translations?.components?.about?.translations || {};
  const about1Image = objectTranslations['about.image.1'];
  const aboutTitleText = objectTranslations['about.title'];
  const aboutBodyText = objectTranslations['about.body'];

  const aboutCheck1Image = objectTranslations['about.check.image.1'];
  const aboutCheck2Image = objectTranslations['about.check.image.2'];
  const aboutCheck3Image = objectTranslations['about.check.image.3'];
  const aboutCheck4Image = objectTranslations['about.check.image.4'];

  return (
    <div id="about" className="about-area area-padding">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="section-headline text-center">
              <h2>{ aboutTilteText }</h2>
            </div>
          </div>
        </div>
        <div className="row">
          {/* single-well start*/}
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="well-left">
              <div className="single-well">
                {/*<a href="#">*/}
                  <img src={ about1Image } alt="" />
                {/*</a>*/}
              </div>
            </div>
          </div>
          {/* single-well end*/}
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="well-middle">
              <div className="single-well">
                {/*<a href="#">*/}
                  <h4 className="sec-head">{ aboutTitleText }</h4>
                {/*</a>*/}
                { aboutBodyText && <div className="about-body" dangerouslySetInnerHTML={{ __html: aboutBodyText }} /> }
                <div className="row about-check-images" style={{ justifyContent: 'center', textAlign: 'center' }}>
                  <div className="col-xs-6 col-md-3" style={{ textAlign: 'center', marginBottom: '12px' }}>
                    { aboutCheck1Image && <img src={ aboutCheck1Image } alt="" style={{ height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain', margin: '0 auto', display: 'block' }} /> }
                  </div>
                  <div className="col-xs-6 col-md-3" style={{ textAlign: 'center', marginBottom: '12px' }}>
                    { aboutCheck2Image && <img src={ aboutCheck2Image } alt="" style={{ height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain', margin: '0 auto', display: 'block' }} /> }
                  </div>
                  <div className="col-xs-6 col-md-3" style={{ textAlign: 'center', marginBottom: '12px' }}>
                    { aboutCheck3Image && <img src={ aboutCheck3Image } alt="" style={{ height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain', margin: '0 auto', display: 'block' }} /> }
                  </div>
                  <div className="col-xs-6 col-md-3" style={{ textAlign: 'center', marginBottom: '12px' }}>
                    { aboutCheck4Image && <img src={ aboutCheck4Image } alt="" style={{ height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain', margin: '0 auto', display: 'block' }} /> }
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End col*/}
        </div>
      </div>
    </div>
  );
};

export default About;
